import posthog from 'posthog-js';

const key = process.env.REACT_APP_POSTHOG_KEY;
const host =
  process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';

if (key) {
  posthog.init(key, {
    api_host: host,
    person_profiles: 'identified_only',
    capture_pageview: false,
    capture_pageleave: true,
  });
}

export default posthog;
